import { SambaAutoLink } from '@betterment/shared-components';
import { Box, Card, Flex, HR } from '@betterment/style-closet-react';

import ClaimedRewardItem from './ClaimedRewardItem';
import { useReferralSenderOffer } from './ReferAFriendProvider';

import { urlBuilder } from '../../Shared/urlBuilder';

const ClaimedRewardsCard: React.FC = () => {
  const { senderOfferFulfillments, hasMaximumInvestingReferrals } = useReferralSenderOffer();

  if (senderOfferFulfillments.length === 0) return null;

  return (
    <Card>
      <Card.Slot name="header">
        <Flex justifyContent="space-between">
          <Box>Claimed rewards</Box>
          <SambaAutoLink to={urlBuilder.appEarnedRewards.absolute()}>See your rewards</SambaAutoLink>
        </Flex>
      </Card.Slot>
      <Card.Slot name="body">
        {senderOfferFulfillments.map((senderOfferFulfillment, index) => {
          const isLastItemInList = senderOfferFulfillments.length - 1 === index;
          const uniqueKey = `${senderOfferFulfillment.offerName}_${index}`;
          return (
            <Box key={uniqueKey}>
              <ClaimedRewardItem {...senderOfferFulfillment} />
              {!isLastItemInList && <HR mt="8" pb="8" />}
            </Box>
          );
        })}

        {hasMaximumInvestingReferrals && (
          <Box mt="8" p="8" backgroundColor="bmtBlue10">
            You have no more available rewards but you can continue referring friends.
          </Box>
        )}
      </Card.Slot>
    </Card>
  );
};

export default ClaimedRewardsCard;
